// extracted by mini-css-extract-plugin
export default {"checkbox":"src-pages-SalesCannelVersion-SalesChannelSettings-SalesChannelCheckout-ChinaFapiao-css-module__checkbox--FoZ37"};